import React from "react";
import { CustomerProvider } from "./customers";
import { ConfigProvider } from "./config";
import { LeaveProvider } from "./leave";
import { TrainingProvider } from "./training";
import { EventProvider } from "./events";
import { ExcursionProvider } from "./excursions";
import { EquipmentProvider } from "./equipment";
import { StatsProvider } from "./stats";
import { QualificationProvider } from "./qualification";
import { MailTemplateProvider } from "./mailTemplates";
import { SMSTemplateProvider } from "./smsTemplates";
import { FollowupProvider } from "./followup";
import { NewsletterProvider } from "./newsletter";
import { BillingProvider } from "./billing";
import { RentalProvider } from "./rental";
import { MobileDevicesProvider } from "./mobileDevices";

export function DomainsProvider(props: { children: React.ReactNode }) {
  return (
    <CustomerProvider>
      <ConfigProvider>
        <LeaveProvider>
          <TrainingProvider>
            <EventProvider>
              <ExcursionProvider>
                <EquipmentProvider>
                  <StatsProvider>
                    <QualificationProvider>
                      <MailTemplateProvider>
                        <SMSTemplateProvider>
                          <FollowupProvider>
                            <NewsletterProvider>
                              <BillingProvider>
                                <RentalProvider>
                                  <MobileDevicesProvider>{props.children}</MobileDevicesProvider>
                                </RentalProvider>
                              </BillingProvider>
                            </NewsletterProvider>
                          </FollowupProvider>
                        </SMSTemplateProvider>
                      </MailTemplateProvider>
                    </QualificationProvider>
                  </StatsProvider>
                </EquipmentProvider>
              </ExcursionProvider>
            </EventProvider>
          </TrainingProvider>
        </LeaveProvider>
      </ConfigProvider>
    </CustomerProvider>
  );
}

export { useCustomer } from "./customers";
export { useConfig } from "./config";
export { useLeave } from "./leave";
export { useTraining } from "./training";
export { useEvent } from "./events";
export { useExcursion } from "./excursions";
export { useEquipment } from "./equipment";
export { useStats } from "./stats";
export { useQualification } from "./qualification";
export { useMailTemplate } from "./mailTemplates";
export { useSMSTemplate } from "./smsTemplates";
export { useFollowup } from "./followup";
export { useNewsletter } from "./newsletter";
export { useBilling } from "./billing";
export { useRental } from "./rental";
export { useMobileDevices } from "./mobileDevices";
export { AuthProvider, AuthContext, useAuth } from "./auth";
export { FetchHeadersProvider } from "./fetchHeaders";
export { RolesProvider, useRoles } from "./roles";
